import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

const roleHome = (role) => {
  const r = (role || '').toLowerCase();
  if (r === 'client') return '/client/dashboard';
  if (r === 'admin' || r === 'developer' || r === 'outreach') return '/admin/dashboard';
  return '/';
};

const ProtectedRoute = ({ children, role }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#030712]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
      </div>
    );
  }

  const allowed = Array.isArray(role)
    ? role.map(r => (r || '').toLowerCase())
    : role
      ? [(role || '').toLowerCase()]
      : null;

  const isAdminArea = allowed
    ? allowed.some(r => ['admin', 'developer', 'outreach'].includes(r))
    : false;

  if (!user) {
    return <Navigate to={isAdminArea ? '/admin/login' : '/login'} replace />;
  }

  if (allowed) {
    const userRole = (user.role || '').toLowerCase();
    if (!allowed.includes(userRole)) {
      return <Navigate to={roleHome(userRole)} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
